import {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

export interface ContextMenuProps {
    onClickCopy?: () => string|undefined,
    onClickPaste?: (content: string|undefined) => void,

    onClickNewTab?: () => void,
    onClickClose?: () => void,
}

export interface ContextMenuRef {
    showModal(left: number, top: number): void;

    dialogRef: HTMLDialogElement;
}

const ContextMenu = forwardRef<ContextMenuRef, ContextMenuProps>(
    (props, ref) => {
        const {t} = useTranslation();
        const dialogRef = useRef<HTMLDialogElement>(null);
        const [position, setPosition] = useState<{ left: number, top: number }>({left: 0, top: 0});

        useImperativeHandle(ref, () => {
            return {
                showModal(mouseLeft: number, mouseTop: number) {
                    if (dialogRef.current!.open) {
                        dialogRef.current!.close();
                    }

                    dialogRef.current!.showModal();

                    let left: number = mouseLeft;
                    let top: number = mouseTop;

                    const dlgRight = left + dialogRef.current!.offsetWidth;
                    const dlgBottom = top + dialogRef.current!.offsetHeight;

                    if (dlgRight > document.body.scrollWidth) {
                        left = document.body.scrollWidth - dialogRef.current!.offsetWidth - 10;
                    }

                    if (left < 10) {
                        left = 10;
                    }


                    if (dlgBottom > document.body.scrollHeight) {
                        top = document.body.scrollHeight - dialogRef.current!.offsetHeight - 10;
                    }

                    if (top < 10) {
                        top = 10;
                    }


                    setPosition({left, top});
                },
                dialogRef: dialogRef.current!
            }
        });

        // async function onClickClose() {
        //     const index = terminal.getActiveTabIndex();
        //     removeTab(index!);
        // }
        //
        // async function onClickCopy() {
        //     const activeTab = terminal.getActiveTabIndex();
        //     const selection = terminal._termArray[activeTab!].content.getSelection();
        //     const text = selection ? selection.toString() : "";
        //     try {
        //         await navigator.clipboard.writeText(text);
        //     } catch (error) {
        //         console.error("Copy failed", error);
        //     }
        // }


        async function onClickCopy() {
            if (!props.onClickCopy) return;

            const text = props.onClickCopy();
            if(!text) {
                console.warn("data empty");
                return
            }

            try {
                await navigator.clipboard.writeText(text);
            } catch (error) {
                console.error("Copy failed", error);
            }
        }

        async function onClickPaste() {
            try {
                if(!props.onClickPaste) return;

                const text = await navigator.clipboard.readText();
                props.onClickPaste(text);
            } catch (error) {
                console.error("Paste failed", error);
            }
        }

        return (
            <dialog ref={dialogRef} className="context_menu" style={{...position}}>
                <ul>
                    <li><a className="menu" onClick={props.onClickClose}>{t("terminal.closeCurrentTab")}(Alt + W)</a></li>
                    <li><a className="menu" onClick={props.onClickNewTab}>{t("terminal.openNewTab")}(Alt + T)</a></li>
                </ul>
                <ul>
                    <li><a className="menu" onClick={onClickCopy}>{t("terminal.copy")}(Ctrl + Shift + C)</a></li>
                    <li><a className="menu" onClick={onClickPaste}>{t("terminal.paste")}(Ctrl + Shift + V)</a></li>
                </ul>
            </dialog>
        );
    });

export default ContextMenu;